import React from 'react';
import './socialpanel.scss';
import { Link } from 'react-router-dom';


class SocialPanel extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <nav className='social-panel f-center'>
        <div className='f-container'>
          <div className='f-row'>
            <div className='f-item f-item-6 f-start'>
              <Link to = '/'>
                <img src='./img/logo/gasap.png' alt='logo' />
              </Link>
            </div>
            <div className='f-item f-item-3'>
              <ul className='social-item-list'>
                {/*<li><i className="fa fa-facebook"><a href="https://www.facebook.com/profile.php?id=100060413831308" target="_blank"></a></i></li>*/}

                {/*
                <li><span> Тел.:</span> +38 (0552) 31-69-00</li>
                <li><span> Моб.:</span> +38 (067) 011-69-00</li>
                <li><span> Моб.:</span> +38 (066) 131-69-00</li>
                */}
                <li><span> Моб.:</span> +38 (063) 616-13-52</li>

                <li><a href="https://www.facebook.com/profile.php?id=100060413831308" target="_blank"><span className="fa-stack fa-lg"><i className="fab fa-facebook fa-stack-2x"></i></span></a></li>
              </ul>
            </div>
            <div className='f-item f-item-3'>
              <ul className='social-item-list btn-social-list'>
                <li><button className='button btn-os-kab'><a href="http://gaz.ukrcom.kherson.ua:8080/gasup" target="_blank"> Особистий кабінет</a></button></li>
                {/*
                  <li><button className='button btn-form-feedback'><a href="https://forms.gle/c929xcJDY9upqp5P8" target="_blank">Форма зворотного зв'язку</a></button></li>
                */}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    );
  };
};

export default SocialPanel;



// WEBPACK FOOTER //
// ./src/client/components/header/socialpanel/socialpanel.jsx